import { DOMChanges, GestureType } from "../../../types"

export const fetchReplayData = async ( s3File: string ): Promise<DOMChanges[]> => {
	const res = await fetch( s3File )
	const blob = await res.blob()
	const stream = blob.stream()

	const chunks: BlobPart[] = []

	await stream
		.pipeThrough(
			new DecompressionStream( 'gzip' )
		)
		.pipeTo(
			new WritableStream( {
				write( chunk ) {
					chunks.push( chunk )
				}
			} )
		)

	const merged = await new Blob( chunks, { type: 'text/plain' } ).text()

	return JSON.parse( merged )
}

type Point = [number, number]

const PointABLength = (a: Point, b: Point) => {
	return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2))
}

export const IsSwipe = ( points: Point[] ) => {
	if ( points.length < 2 ) {
		return false
	}

	let totalDistance = 0

	const startPoint = points[0]
	const endPoint = points[points.length - 1]

	const straightLineDistance = PointABLength( startPoint, endPoint )

	for( let i = 0; i < points.length - 1; i++ ) {
		totalDistance += PointABLength( points[i], points[i + 1] )
	}

	const linearityRatio = straightLineDistance / totalDistance

	const linearityThreshold = 0.8
	const minSwipeDistance = 30

	return linearityRatio > linearityThreshold && straightLineDistance > minSwipeDistance
}


export const SwipeDirection = ( points: Point[] ): GestureType => {
	// check the highest direction of travel, between start and end points
	const startPoint = points[0]
	const endPoint = points[points.length - 1]

	const xDiff = endPoint[0] - startPoint[0]
	const yDiff = endPoint[1] - startPoint[1]

	if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
		return xDiff > 0 ? GestureType.SWIPE_RIGHT : GestureType.SWIPE_LEFT
	} else {
		return yDiff > 0 ? GestureType.SWIPE_DOWN : GestureType.SWIPE_UP
	}
}